module.exports = __webpack_public_path__ + "static/media/ross-beschler.68eb417b.md";